import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ChatContent, ChatLayoutClose, TextBox } from '~/components/Chat';
import { ChatRoomErrorBoundary } from '~/components/ErrorBoundary';
import { Toast } from '~/components/atomic';
import { HelmetHead } from '~/components/common';
import ChatLeaveMessage from '~/components/common/ChatLeaveMessage/ChatLeaveMessage';
import { useCommonChatState, useGetChatList, useWebSocket } from '~/hooks';
import { MessageResponse } from '~/types';
import { useUserStore, useCommonChatStore } from '~/store';
import ThreeJSBackground from '../ChatConcept/Background';
import InputHeightContainer from '../Mystery/Chat/InputHeightContainer';
import * as S from './index.styled';

export default function ChatThree() {
  const { id: chatroomId } = useParams();
  const email = useUserStore((state) => state.email);

  const { isWaitingChatRoomInfo, setIsWaitingChatRoomInfo } =
    useCommonChatStore((state) => ({
      isWaitingChatRoomInfo: state.isWaitingChatRoomInfo,
      setIsWaitingChatRoomInfo: state.setIsWaitingChatRoomInfo,
    }));

  const { room_type, safe_chat } = useCommonChatStore((state) => ({
    room_type: state.roomType,
    safe_chat: state.isSafeChatOn,
  }));

  const [messages, setMessages] = useState<MessageResponse[]>([]);
  const [socketConnectSuccess, setSocketConnectSuccess] = useState(false);

  const { webSocket, socketClose, waitingChat, setWaitingChat } = useWebSocket({
    chatRoomId: chatroomId,
    chatType: 'personal',
    fetchDone: true,
    email,
    setMessages,
    socketConnectSuccess,
    setSocketConnectSuccess,
  });

  const {
    showCharacter,
    avatarInfo,
    showLeaveRoomOpen,
    setShowLeaveRoomOpen,
    handleChatLayoutClose,
    isChatLayoutShow,
    handleRoomLeaveClick,
    isLeaveRoomPending,
    handleSetWaitingChatTrue,
  } = useCommonChatState({
    chatType: 'personal',
    chatRoomId: chatroomId,
    email,
    setWaitingChat,
  });

  const {
    isChatRoomError,
    title,
    isPaginationPending,
    infoMessageRef,
    chatSectionRef,
    prevHeight,
  } = useGetChatList({
    chatroomId,
    email,
    socketConnectSuccess,
    setMessages,
    chatType: 'personal',
    successEnter: true,
  });

  useEffect(() => {
    if (socketConnectSuccess) return;
    setIsWaitingChatRoomInfo(true);
  }, [socketConnectSuccess]);

  if (isChatRoomError) {
    return <ChatRoomErrorBoundary />;
  }

  return (
    <>
      <HelmetHead title={title || 'Chat'} />

      {/* {isLeaveRoomPending && <FullScreenLoading />} */}
      {socketClose && <Toast type='error' text='socket close' />}

      <S.Container>
        {isChatLayoutShow && (
          <S.ChatContainer
            isChatLayoutShow={isChatLayoutShow}
            showCharacter={showCharacter}
          >
            <ChatContent
              type={'single'}
              messages={messages}
              isLoading={isWaitingChatRoomInfo}
              waitingChat={waitingChat}
              isPaginationPending={isPaginationPending}
              infoMessageRef={infoMessageRef}
              chatSectionRef={chatSectionRef}
              prevHeight={prevHeight}
            />
            <InputHeightContainer />
          </S.ChatContainer>
        )}
        <ThreeJSBackground
          avatarInfo={avatarInfo}
          isAvatarVisible={showCharacter}
          isOverviewMode={!isChatLayoutShow}
        />
        {title && chatroomId && (
          <TextBox
            waitingChat={waitingChat}
            webSocket={webSocket}
            chatroomId={chatroomId}
            setWaitingChatTrue={handleSetWaitingChatTrue}
            setMessages={setMessages}
            room_type={room_type ? room_type : 'user'}
            safe_chat={safe_chat}
          />
        )}
        {title && isChatLayoutShow && (
          <ChatLayoutClose onClick={handleChatLayoutClose} />
        )}
      </S.Container>

      <ChatLeaveMessage
        group={false}
        isOpen={showLeaveRoomOpen}
        onClose={() => setShowLeaveRoomOpen(false)}
        handleRoomLeaveClick={handleRoomLeaveClick}
      />

      {/* <VideoCallModal
        isOpen={showVideoCallModal}
        setIsOpen={setShowVideoCallModal}
      /> */}
    </>
  );
}
